var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99805 3.99905V7.99811L10.6641 9.33113",
    stroke: "currentColor",
    strokeWidth: 1.33302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9981 14.6632C11.6791 14.6632 14.6632 11.6791 14.6632 7.9981C14.6632 4.31707 11.6791 1.33301 7.9981 1.33301C4.31707 1.33301 1.33301 4.31707 1.33301 7.9981C1.33301 11.6791 4.31707 14.6632 7.9981 14.6632Z",
    stroke: "currentColor",
    strokeWidth: 1.33302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.4fc8e40310a8c4de534ab135eefffff1.svg";
export { ForwardRef as ReactComponent };